import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportSchema } from "./SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportSchema";
import SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportInstructions from "./instructions";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SignatureImageImproved } from "../../utils/SignatureImage";

const {
  appPropertiesSection,
  remarksSection,
  groupNormalReverseAndDecodeRemarks,
} = SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportSchema;

class ReportView extends Component {
  render() {
    const { props } = this;
    let reportData = props.reportData ? props.reportData : {};
    let { signatureImage } = props;
    let { location, user, date, assets } = reportData;
    if (!Array.isArray(assets)) assets = [];

    let data = {
      location: location,
      user: user ? user.name : "",
      reportDate: dataFormatters.dateFormatter(date),
      assets: assets,
    };

    const groupedAssets = groupNormalReverseAndDecodeRemarks(data.assets);
    return (
      <Fragment>
        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <ReportTitleSection title="SUBURBAN OPERATIONS DIVISION TURNOUT INSPECTION REPORT" {...props} centerTitle={true} />

          <ReportInfoSection
            fontSizeOverride={"20px"}
            rows={[
              {
                col1: {
                  title: "Line / Mode",
                  value: data.location,
                },
                col2: {
                  title: "Date",
                  value: data.reportDate,
                },
              },
              {
                col1: {
                  title: "Inspector",
                  value: data.user,
                },
                col2: {
                  title: "Signature",
                  value: <SignatureImageImproved signatureImage={signatureImage} />,
                },
              },
            ]}
          />
          <span className="spacer"></span>
          <table className="table-bordered" style={{ marginBottom: 0 }}>
            <ReportTableSectionRenderer section={appPropertiesSection} rowsData={groupedAssets} />
          </table>
          <table className="table-bordered" style={{ marginBottom: 0 }}>
            <ReportTableSectionRenderer section={remarksSection} rowsData={groupedAssets} />
          </table>
        </div>
        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportInstructions />
        </div>
      </Fragment>
    );
  }
}

const SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm = (props) => {
  const { inspec, isPreview } = props;
  if (isPreview) {
    return <ReportView reportData={{}} isPreview={true} />;
  }

  return (
    <ReportView
      {...props}
      reportData={{
        assets: ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, getAllowedSwitches, "septaSubOpDivTurnoutInspectionForm"),
        location: ReportGeneratorUtils.getInspectionLocation(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
      }}
    />
  );
};

export default SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm;



// WEBPACK FOOTER //
// ./src/components/Reports/SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm/index.jsx